import classNames from 'classnames';

interface GrecaptchaTosProps {
  className?: string;
}

export default function GrecaptchaTos({
  className,
  ...passthroughProps
}: GrecaptchaTosProps) {
  return (
    <small
      className={classNames('grecaptcha-tos', className)}
      {...passthroughProps}
    >
      This site is protected by reCAPTCHA and the Google{' '}
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
      <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </small>
  );
}
